/**
 * The venue name and time pill on a `WorkshopList` card. Each is
 * independently switchable, and both scale with the row's size.
 */
import type { WorkshopListSize } from './workshopListSizes';
import { WORKSHOP_LIST_SIZES } from './workshopListSizes';

const ELLIPSIS = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export interface WorkshopListHeaderProps {
  venueName: string;
  showVenue: boolean;
  time: string;
  showTime: boolean;
  size?: WorkshopListSize;
}

export function WorkshopListHeader({
  venueName,
  showVenue,
  time,
  showTime,
  size = 'md',
}: WorkshopListHeaderProps) {
  if (!showVenue && !showTime) return null;
  const z = WORKSHOP_LIST_SIZES[size];
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {showVenue && (
        <span
          className="nb-display"
          style={{
            fontSize: z.venue,
            letterSpacing: '.02em',
            textTransform: 'uppercase',
            color: 'var(--nb-bark-dark)',
            ...ELLIPSIS,
          }}
        >
          {venueName}
        </span>
      )}
      {showTime && (
        <span
          style={{
            marginLeft: 'auto',
            flexShrink: 0,
            fontSize: z.pill,
            fontWeight: 800,
            background: 'var(--nb-primary-soft)',
            color: 'var(--nb-bark-dark)',
            borderRadius: 999,
            padding: '2px 8px',
          }}
        >
          {time}
        </span>
      )}
    </div>
  );
}
